import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../css/pdf-viewer.scss";
import defaultLogo from "../Assets/seoimg/logo.png";
import { DottLoader1 } from "../share/loader";
import { useNavigate } from "react-router-dom";
import KeywordPdf from "../share/pdf/keyword";
import { BlobProvider } from "@react-pdf/renderer";
import backIcon from "../Assets/common/back.svg";
import RankTrackingPdf from "../share/pdf/ranktracking.pdf";
import { ZustandStore } from "../../store/zustand-store";
import AddProjectStore from "../../store/AddProjectStore";
import axios from "axios";
import { GET_PDF_DATA, POST_PDF_DATA } from "../../services/constants";
import CustomSlider from "../share/components/CustomSlider";
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@mui/material";
import { stringToBoolean } from "../../helperJs/helper";
import CompetitorPdf from "../share/pdf/competitor.pdf";
import { useTranslation } from "react-i18next";
import { getCurrentYear } from "../share/helper-js/current-year";
import { useBuyAddonHandler } from "../share/custom-hook/useBuyAddonHandler";

function PdfViewer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { customer_plan } = ZustandStore((state) => state);
  const { appliedWhiteLable } = AddProjectStore((state) => state);
  let pdf_editable = stringToBoolean(customer_plan?.whitelabel) || false;
  const { handleAddonPlan } = useBuyAddonHandler();

  const user_email = useSelector((state) => state.email);
  const email = localStorage.getItem("admin_mail");
  const pdfData = useSelector((state) => state.pdfviewerdata);
  const [pdfLogo, setPdfLogo] = useState({
    src: appliedWhiteLable?.header_logo || null,
    position: "flex-start",
    type: null,
  });
  const [footerText, setFooterText] = useState("");
  const [pdfNewData, setPdfNewData] = useState({
    reset: true,
    logo: {
      src: appliedWhiteLable?.header_logo || null,
      position: "flex-start",
      type: null,
    },
    footer: pdf_editable
      ? ""
      : `Copyright ${getCurrentYear} | Prepared using RanksPro.io`,
  });

  const [SaveData, setSaveData] = useState([]);
  const [SaveStatus, setSaveStatus] = useState(false);

  const handleSaveData = () => {
    if (!user_email) return;
    axios.get(GET_PDF_DATA(user_email)).then((response) => {
      const data = response.data;
      if (data.msg === "No Profile Picture found") {
        setSaveData([]);
      } else {
        setSaveData(data);
      }
    });
  };

  useEffect(() => {
    handleSaveData();
  }, [user_email]);

  useEffect(() => {
    const checkArrayIsEmpty = () => {
      if (pdfData.length === 0) {
        navigate(-1);
      }
    };
    dispatch({ type: "NOTLOADING" });
    const timeoutId = setTimeout(checkArrayIsEmpty, 10000);
    return () => clearTimeout(timeoutId);
  }, [pdfData]);

  const processFile = (file) => {
    if (file) {
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPdfLogo((prevPdfLogo) => ({
            ...prevPdfLogo,
            src: reader.result,
            type: file,
          }));
        };
        reader.readAsDataURL(file);
      } else {
        alert("Unsupported file type. Please upload an image or a PDF.");
        setPdfLogo((prevPdfLogo) => ({
          ...prevPdfLogo,
          src: appliedWhiteLable?.header_logo || null,
          type: null,
        }));
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    processFile(file);
    document.getElementById("file-input").value = "";
  };

  const handleUpload = () => {
    console.log("File uploaded:", pdfLogo.type);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    processFile(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handlePdfLogoSave = () => {
    let data = new FormData();
    data.append("img", pdfLogo.type);
    data.append("user_name", user_email);
    data.append(
      "footer",
      footerText || "Copyright 2024 | Prepared using RanksPro.io"
    );
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: POST_PDF_DATA(),
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: data,
    };

    axios
      .request(config)
      .then(() => {
        handleSaveData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const newPdfUpdatedData = () => {
    const data = {
      logo: pdfLogo,
      footer: footerText,
      reset: false,
    };
    if (pdfLogo.type && SaveStatus) {
      handlePdfLogoSave();
    }
    pdf_editable && setPdfNewData(data);
  };

  const resetPdfUpdatedData = () => {
    const data = {
      logo: {
        src: appliedWhiteLable?.header_logo || null,
        position: "flex-start",
        type: null,
      },
      footer: "",
      reset: true,
    };
    setPdfLogo({
      src: appliedWhiteLable?.header_logo || null,
      position: "flex-start",
      type: null,
    });
    setPdfNewData(data);
  };

  const handleBackButton = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/dashboard");
    }
  };

  const handleLogoUpdate = (src, text) => {
    setFooterText(text);
    setPdfLogo((prevPdfLogo) => ({
      ...prevPdfLogo,
      src: src,
      type: null,
    }));
  };

  const addonWhiteLabel =
    "https://buy.stripe.com/00g8z7aZg7R81YA6po" + `?prefilled_email=${email}`;

  return (
    <>
      <button className="icon-btn large-btn mt-3" onClick={handleBackButton}>
        <img src={backIcon} alt="" className="me-1" /> Back
      </button>
      <div className="pdf-viewer-container row gy-3">
        <div className="pdf-update-sec col-12 col-md-5 col-lg-4">
          <h1>{t("pdf_view.title")}</h1>
          <div className="img-box mb-2">
            <img src={pdfLogo?.src || defaultLogo} alt="brand-logo" />
          </div>
          <CustomSlider
            data={SaveData}
            handleAction={handleLogoUpdate}
            src={pdfLogo?.src}
          />
          <div className="pdf-edit-view mt-3">
            {pdf_editable ? null : (
              <div className="pdf-editable">
                <div className="pdf-box-upgrade">
                  <p>{t("pdf_view.buy_addon")}</p>
                  <button
                    className="anchor-hover ms-1"
                    onClick={() => handleAddonPlan(addonWhiteLabel)}
                  >
                    {t("guest_link.add_on")}
                  </button>
                </div>
              </div>
            )}
            <div style={{ filter: pdf_editable ? "none" : "blur(2px)" }}>
              <div className="change-logo">
                <label>{t("pdf_view.change_brand_logo")}</label>
                <div
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  style={{
                    border: "2px dashed #ccc",
                    borderRadius: "4px",
                    padding: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                    position: "relative",
                    height: "100px",
                  }}
                  className="mt-2"
                >
                  <label
                    htmlFor="file-input"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      flexDirection: "column",
                    }}
                    className="d-flex align-items-center justify-content-center"
                  >
                    {/* <MdCloudUpload /> */}
                    <p className="mb-0">{t("pdf_view.drag_and_drop")}</p>
                  </label>
                  <input
                    id="file-input"
                    name="file-input"
                    disabled={!pdf_editable}
                    type="file"
                    accept="image/*, application/pdf"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </div>
                {/* <input type="checkbox" /> */}
              </div>
              <div className="mt-3 logo-position">
                <p className="mb-1">{t("pdf_view.please_select_logo")}</p>
                <div className="d-flex radio-btn">
                  <label htmlFor="flex-start">{t("pdf_view.start")}</label>
                  <input
                    type="radio"
                    id="flex-start"
                    name="positions"
                    value="flex-start"
                    checked={pdfLogo.position === "flex-start"}
                    onChange={() =>
                      pdf_editable &&
                      setPdfLogo((prevPdfLogo) => ({
                        ...prevPdfLogo,
                        position: "flex-start",
                      }))
                    }
                  />
                  <label htmlFor="center">{t("pdf_view.center")}</label>
                  <input
                    type="radio"
                    id="center"
                    name="positions"
                    value="center"
                    checked={pdfLogo.position === "center"}
                    onChange={() =>
                      pdf_editable &&
                      setPdfLogo((prevPdfLogo) => ({
                        ...prevPdfLogo,
                        position: "center",
                      }))
                    }
                  />
                  <label htmlFor="flex-end">{t("pdf_view.end")}</label>
                  <input
                    type="radio"
                    id="flex-end"
                    name="positions"
                    value="flex-end"
                    checked={pdfLogo.position === "flex-end"}
                    onChange={() =>
                      pdf_editable &&
                      setPdfLogo((prevPdfLogo) => ({
                        ...prevPdfLogo,
                        position: "flex-end",
                      }))
                    }
                  />
                </div>
              </div>
              <div className="mt-3 change-footer">
                <label htmlFor="footer-input">
                  {t("pdf_view.change_pdf_footer")}
                </label>
                <input
                  type="text"
                  id="footer-input"
                  name="footer-input"
                  disabled={!pdf_editable}
                  className="mt-2"
                  placeholder={t(
                    "rank_tracking.rank_tracker.project_setting_button.report_schedule_modal.form.upload_photo_and_footer.footer_placeholder"
                  )}
                  value={footerText}
                  onChange={(e) => setFooterText(e.target.value)}
                />
                <div className="footer-notes">
                  <span>*</span>
                  <small>{t("pdf_view.footer_blank")}</small>
                </div>
              </div>

              <FormControl component="fieldset">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={SaveStatus}
                        onChange={() => setSaveStatus((pre) => !pre)}
                        color="primary"
                      />
                    }
                    label="Save Logo and Footer as Default"
                    labelPlacement="end"
                    sx={{
                      justifyContent: "start",
                    }}
                  />
                </FormGroup>
              </FormControl>
              <div className="colloction-btn">
                <button
                  onClick={newPdfUpdatedData}
                  className="btn_3"
                  disabled={!pdf_editable}
                >
                  {t("pdf_view.update_pdf")}
                </button>
                <button
                  onClick={resetPdfUpdatedData}
                  className="btn_3"
                  disabled={!pdf_editable}
                >
                  {t("pdf_view.reset_pdf")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-12 col-md-7 col-lg-8 pdf-view-sec"
          style={{ minHeight: "60vh" }}
        >
          {pdfData?.length === 0 ? (
            <div className="loader">
              <DottLoader1 />
            </div>
          ) : (
            <BlobProvider
              document={
                pdfData?.type === "rank" ||
                pdfData?.type === "map" ||
                pdfData?.type === "llm" ? (
                  <RankTrackingPdf
                    table_data={pdfData?.data}
                    whiteLabel={pdfNewData}
                  />
                ) : pdfData?.type === "competitor" ? (
                  <>
                    <CompetitorPdf
                      table_data={pdfData?.data}
                      whiteLabel={pdfNewData}
                    />
                  </>
                ) : (
                  <KeywordPdf
                    data={pdfData?.data?.data}
                    Src={pdfData?.data?.src}
                    newData={pdfNewData}
                  />
                )
              }
            >
              {({ url, loading }) => {
                return loading ? (
                  <div className="loader">
                    <DottLoader1 />
                  </div>
                ) : (
                  <div style={{ height: "100vh" }}>
                    <object
                      data={url}
                      type="application/pdf"
                      width="100%"
                      height="100%"
                    >
                      <p>{t("pdf_view.message")}</p>
                      <a
                        target="_blank"
                        href={url}
                        download={`SEO Tools: WhiteLabel.pdf`}
                      >
                        {t("pdf_view.download_pdf")}
                      </a>
                    </object>
                  </div>
                );
              }}
            </BlobProvider>
          )}
        </div>
      </div>
    </>
  );
}

export default PdfViewer;
